<template>
	<div class="check-outBox" @click.stop="clickItem">
		<div class="check-box" :class="{'active':itemChecked}">
  	</div>
	</div>
  
</template>

<script>
	export default {
    name: '',
    data () {
      return {
      }
    },
    props:{
    	itemChecked:{
    		type:Boolean,
    		default:false
    	}
    },
    methods:{
    	clickItem(){
    		this.$emit('clickItem')
    	}
    },
    components:{
        
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" type="text/scss" rel="stylesheet/scss" scoped>
.check-outBox{
	padding: .15rem 0;
	padding-right: .05rem;
	.check-box{
		width: .15rem;
		height: .15rem;
		border: 1px solid #ddd;
		border-radius: .1rem;
		&.active{
			background:url(../../assets/check-icon.png) no-repeat center;
			background-size: .15rem .15rem;
		}
	}
}
	
</style>


// WEBPACK FOOTER //
// src/basic/checkItem/checkItem.vue